import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CurrencyFilter from './utils/currency.filter'
import DateFilter from './utils/date.filter'
import Notifications from 'vue-notification'
import VTooltip from 'v-tooltip'



Vue.config.productionTip = false

Vue.filter('currency', CurrencyFilter)
Vue.filter('date', DateFilter)

Vue.use(Loading)
Vue.use(Notifications)
Vue.use(VTooltip)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
